import React from 'react';
import { motion } from 'framer-motion';
import { Search, Heart, Compass } from 'lucide-react';
export function ThreePillars() {
  const pillars = [{
    icon: Search,
    title: 'Pilar 1 — Diagnóstico consciente',
    text: 'Identificar cómo la rutina se fue instalando y de qué forma está afectando la intimidad hoy.'
  }, {
    icon: Heart,
    title: 'Pilar 2 — 18 Métodos de profundización',
    text: 'No vienes a “aprender trucos”. Vienes a volver a encontrarte desde un lugar más profundo, consciente y vivo.'
  }, {
    icon: Compass,
    title: 'Pilar 3 — Nuevo comienzo guiado',
    text: 'Elegir qué necesita hoy tu relación y salir con dirección clara para sostenerlo.'
  }];
  return <section className="py-24 bg-[#FAF7F2] text-[#0A0A0A]" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4" data-id="element-145">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-146">
          <h2 className="text-4xl md:text-5xl font-serif text-[#0A0A0A]" data-id="element-147">
            Los 3 Pilares de la Inmersión
          </h2>
          <div className="w-24 h-1 bg-[#C5A55A] mx-auto mt-6" data-id="element-148"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-149">
          {pillars.map((pillar, idx) => <motion.div key={idx} className="bg-white p-8 rounded-sm shadow-lg border-t-4 border-[#C5A55A] hover:shadow-2xl transition-shadow duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} data-id="element-150">
              <div className="bg-[#FAF7F2] w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-151">
                <pillar.icon className="w-8 h-8 text-[#C5A55A]" data-id="element-152" />
              </div>
              <h3 className="text-xl font-bold text-center mb-4 font-serif" data-id="element-153">
                {pillar.title}
              </h3>
              <p className="text-[#555] text-center leading-relaxed" data-id="element-154">
                {pillar.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}